import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import EngineLocationService from "@services/EngineLocationService";

const ShowEngineLocation = ({ engineLocation }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [engineLocationData, setEngineLocationData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      EngineLocationService.find(engineLocation.id).then((response) => {
        setEngineLocationData(response.data.data);
      });
  }, [engineLocation.id, showModal]);

  return (
    <PermissionHandler permission={"view_engine_locations"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={engineLocationData.name} />
          <RowDetails
            label={t("nameEng")}
            value={engineLocationData.name_eng}
          />
          <RowDetails
            label={t("description")}
            value={engineLocationData.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowEngineLocation;
